import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'ShippingDetailsSection.title',
    defaultMessage: 'Shipping details',
    description: 'Title of the shipping details section',
  },
  overview: {
    shippingMethod: {
      id: 'properties.shippingMethod',
      defaultMessage: 'Shipping method',
      description: 'Shipping method property translation',
    },
    servicePoint: {
      id: 'properties.servicePoint',
      defaultMessage: 'Service point',
      description: 'Service point property translation',
    },
    isSplitAllowed: {
      id: 'properties.isSplitAllowed',
      defaultMessage: 'Split allowed',
      description: 'Is split allowed property translation',
    },
    deliveryAt: {
      id: 'properties.deliveryAt',
      defaultMessage: 'Delivery at',
      description: 'delivery at property translation',
    },
  },
};

export default defineMessages(translations);
